module.exports = __webpack_public_path__ + "static/img/logo_impo.0c24cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/logo_impo.png
// module id = b1yb
// module chunks = 232